import { Controller } from '@hotwired/stimulus'

// Detail view
// Clicking #toggle will append a <template> AFTER the current element. Allowing
// you to "expand" a detail view, similar to a collapse, but lets you inline a
// <tr> in a <table>
//
// Example usage:
// <tr data-controller="detail-view">
//   <td data-action="click->detail-view#toggle">
//     Click me to expand
//     <template data-detail-view-target="detailView">
//       <tr><td colspan="100%">Expanded content here</td></tr>
//     </template>
//   </td>
// </tr>
export default class extends Controller {
    static targets = ['detailView']

    #isExpanded = false
    #expandedView = null

    connect() {
        // Check if already expanded on connect (Turbo cached back button support)
        const existingExpandedView = this.element.nextElementSibling
        if (
            existingExpandedView &&
            existingExpandedView.hasAttribute('data-detail-view-expanded')
        ) {
            this.#expandedView = existingExpandedView
            this.#isExpanded = true
            this.#showIcon('collapse')
        }
    }

    toggle() {
        this.#isExpanded = !this.#isExpanded
        this.#isExpanded ? this.#expand() : this.#collapse()
    }

    // Clone <template> and append it after the current element
    #expand() {
        const clonedTemplate = this.detailViewTarget.content.cloneNode(true)
        this.#expandedView = clonedTemplate.firstElementChild
        this.#expandedView.dataset.detailViewExpanded = '' // Flag element as expanded
        this.element.insertAdjacentElement('afterend', this.#expandedView)
        this.#showIcon('collapse')
    }

    #collapse() {
        this.#expandedView?.remove()
        this.#showIcon('expand')
    }

    #showIcon(icon) {
        this.element.dataset.chevronLoadingIconsVisibleIconValue = icon
    }
}
